import { ErrorHandler, inject, Injectable } from '@angular/core';
import { generateErrorId } from '../shared/utils/unique-id-utils';
import { ClientLoggingService } from './services/client-logging.service';
import { Toast } from '../shared/types/toast';
import { environment } from '../../environments/environment';
import { LayoutStore, LayoutStoreType } from './store/layout.store';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
    private loggingService = inject(ClientLoggingService);
    private layoutStore: LayoutStoreType = inject(LayoutStore);

    public handleError(error: any): void {
        if (!environment.production) {
            console.log(error);
        }

        const correlationId = generateErrorId();
        this.loggingService.log(correlationId, error);
        this.layoutStore.addToast(
            new Toast(correlationId, [
                `An error occurred, please refresh the page and try again`,
                `Correlation Id: ${correlationId}`,
            ]),
        );
    }
}
